import React from "react";
import { ChevronLeft, ChevronRight, Play } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export function MediaTile({ m, onOpen }) {
  return (
    <button onClick={onOpen} data-testid={`gallery-item-${m.id}`} className="group relative block w-full overflow-hidden rounded-xl aspect-[4/3] bg-slate-100">
      {m.type === "video" ? (
        <>
          <video src={m.url} className="h-full w-full object-cover" muted preload="metadata" />
          <div className="absolute inset-0 flex items-center justify-center bg-black/30">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white/90 text-navy"><Play className="h-6 w-6 ml-1" /></span>
          </div>
        </>
      ) : (
        <img src={m.url} alt={m.caption || ""} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      )}
      {m.caption && <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-3 text-left text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity">{m.caption}</div>}
    </button>
  );
}

export function Lightbox({ items, index, setIndex }) {
  const m = index !== null ? items[index] : null;
  const go = (d) => setIndex((index + d + items.length) % items.length);
  return (
    <Dialog open={!!m} onOpenChange={(o) => !o && setIndex(null)}>
      <DialogContent className="max-w-4xl p-2 bg-navy-void border-none" data-testid="gallery-lightbox">
        {m && (
          <div className="relative">
            {m.type === "video"
              ? <video key={m.id} src={m.url} controls autoPlay className="w-full rounded-lg max-h-[78vh]" />
              : <img src={m.url} alt={m.caption || ""} className="w-full rounded-lg max-h-[78vh] object-contain" />}
            {items.length > 1 && (
              <>
                <button onClick={() => go(-1)} data-testid="lightbox-prev" className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-2 text-navy hover:bg-white"><ChevronLeft className="h-5 w-5" /></button>
                <button onClick={() => go(1)} data-testid="lightbox-next" className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/90 p-2 text-navy hover:bg-white"><ChevronRight className="h-5 w-5" /></button>
              </>
            )}
            <div className="flex items-center justify-between px-2 py-2 text-sm text-white/80">
              <span>{m.caption || m.project_name}</span>
              <span data-testid="lightbox-counter">{index + 1} / {items.length}</span>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
